export const tableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: "Nombre y Apellidos",
                    type: 'text',
                    key: 'name',

                },
                {
                    title: "C.I./Nº Identificación",
                    type: 'text',
                    key: 'taxid',

                },
                {
                    title: "E-mail",
                    type: 'text',
                    key: 'email',

                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}